var _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHistoryIcon = function SvgHistoryIcon(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "history_icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "current",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Time-Copy",
    transform: "translate(5.000000, 4.000000)",
    stroke: "current",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40,22.4630428 C39.9991519,33.5087113 31.0443964,42.4626188 19.9983039,42.4617707 C8.95263537,42.4609227 -0.000848068524,33.5057431 0,22.4600746",
    id: "Path",
    strokeDasharray: "3.75,7.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 10.4617707,
    x2: 20,
    y2: 22.4617707,
    id: "Line-6"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 23.4617707,
    x2: 26.6568542,
    y2: 26.1186247,
    id: "Line-6-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1759861,7.35356627 C30.5540556,3.7143434 25.5400861,1.46177072 20,1.46177072 C8.954305,1.46177072 0,10.4160757 0,21.4617707",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    transform: "translate(32.992228, 6.457885) rotate(132.000000) translate(-32.992228, -6.457885) ",
    points: "27 9.45399857 32.9922278 3.46177072 38.9844557 9.45399857"
  }))))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHistoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history_icon.67fbe76c.svg";
export { ForwardRef as ReactComponent };